/* eslint-disable @typescript-eslint/camelcase */
export default {
  home: {
    sc_o: 'navigation_my_startpage',
    sc_o_PropActionOrigin: 'navigation_badge_no_badge',
  },
  contacts: {
    sc_o: 'navigation_contacts',
    sc_o_PropActionOrigin: [
      'navigation_badge_contacts',
      'navigation_badge_no_badge',
    ],
  },
  messages: {
    sc_o: 'navigation_messages',
    sc_o_PropActionOrigin: [
      'navigation_badge_messages',
      'navigation_badge_no_badge',
    ],
  },
  premium: {
    sc_o: 'navigation_premium',
    sc_o_PropActionOrigin: 'navigation_badge_no_badge',
  },
  probusiness: {
    sc_o: 'navigation_probusiness',
    sc_o_PropActionOrigin: 'navigation_badge_no_badge',
  },
  jobs: {
    sc_o: 'navigation_jobs',
    sc_o_PropActionOrigin: [
      'navigation_badge_jobs',
      'navigation_badge_no_badge',
    ],
  },
  events: {
    sc_o: 'navigation_events',
    sc_o_PropActionOrigin: [
      'navigation_badge_events',
      'navigation_badge_no_badge',
    ],
  },
  content: {
    sc_o: 'navigation_news',
    sc_o_PropActionOrigin: [
      'navigation_badge_news',
      'navigation_badge_no_badge',
    ],
  },
  groups: {
    sc_o: 'navigation_groups',
    sc_o_PropActionOrigin: [
      'navigation_badge_groups',
      'navigation_badge_no_badge',
    ],
  },
  companies: {
    sc_o: 'navigation_companies',
    sc_o_PropActionOrigin: 'navigation_badge_no_badge',
  },
  campus: {
    sc_o: 'navigation_campus',
    sc_o_PropActionOrigin: 'navigation_badge_no_badge',
  },

  business: {
    sc_o: 'navigation_business_solutions',
    sc_o_PropActionOrigin: 'navigation_badge_no_badge',
  },
  services: {
    sc_o: 'navigation_other_services',
    sc_o_PropActionOrigin: 'navigation_badge_no_badge',
  },
  profile: {
    sc_o: 'navigation_profile',
    sc_o_PropActionOrigin: [
      'navigation_badge_profile',
      'navigation_badge_no_badge',
    ],
  },
};
